module.exports = __webpack_public_path__ + "static/media/Header.0b5a0317.jpg";